<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm10 md7>
          <h3 class="text-center">Create TIKO Request <small>for clients</small></h3>
          <v-card>
            <v-card-text>
              <create-form :clients="clients"></create-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const CreateForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "tiko-requests" */ '@/Components/Tiko/create')

  export default {
    name: 'CreateTikoRequest',
    layout,
    props: [
      'clients'
    ],
    components: {
      CreateForm,
    },
    metaInfo () {
      return {
        title: 'Create TIKO Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>
